module.exports = __webpack_public_path__ + "static/img/2.1739e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2.png
// module id = UT21
// module chunks = 0